import { render, staticRenderFns } from "./RTapBenefits.vue?vue&type=template&id=258c96b8&"
import script from "./RTapBenefits.vue?vue&type=script&lang=js&"
export * from "./RTapBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports